<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1">
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary"
            >
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewProduct" class="btn btn-primary">
              Create Config
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item"
                >
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.catalogName }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              :disabled="isDisabled"
              alternative=""
              label="Config KeyName"
              input-classes="form-control"
              v-model="productModel.name"
            />
          </div>
          <div class="col-lg-6">
            <div class="form-group has-label" id="hallo">
              <label class="form-control-label"> Brand Code </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select merchant item"
                :isDisabled="isDisabled"
              >
              </model-list-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label"> Config Value </label>
              <v-jsoneditor
                v-model="jsonModel"
                :plus="true"
                :options="options"
                height="350px"
              />
            </div>
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button v-on:click="createUpdateProdutcs" class="btn btn-primary">
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "configList",
  data() {
    return {
      watch_brand_code : "PHFortune",
      options: {
        modes: ["text", "code", "tree", "form", "view"],
        mode: "form",
      },
      allConfiguration: [],
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      isDisabled: false,
      brandCodeOption: [
        { text: "Fortune", value: "PHFortune" },
        { text: "Chesterfield", value: "PHChe" },
        { text: "Global", value: "Global" },
      ],
      stockPeriodOption: [
        { text: "Weekly", value: 1 },
        { text: "Monthly", value: 2 },
        { text: "Campaign Period", value: 3 },
      ],
      titlePopup: "Create",
      message: null,
      jsonModel: {},
      productModel: {
        brandCode: "PHFortune",
        name: "",
        value: "",
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brandCode",
          sort: true,
        },
        {
          label: "Key Name",
          name: "name",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.onRefreshData();
    this.mappingRole();
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('globalconfiguration')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('globalconfiguration')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }

      if (isAdministrator)
      {
        this.brandCodeOption.push({ text: "Global", value: "Global" });
      }
    },
    onResetForm() {
      this.productModel = {
        brandCode: this.watch_brand_code,
        name: "",
        value: "",
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
      };
      this.isDisabled = false;
    },
    onCreateNewProduct() {
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.onResetForm();
      this.jsonModel = "";
    },
    toggleActive() {},
    async onRefreshData() {
      api_loyalty
        .GetAllGlobalConfig(this.productModel.brandCode)
        .then((data) =>
        {
          try
          {
            if(data.isSuccess){
              this.rows = data.data;
              this.allConfiguration = data.data;
            }
          } catch (e)
          {
            console.log(e);
          }
        });
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.productModel = this.allConfiguration.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.jsonModel = this.isJson(this.selectedItems[0].value)
        ? JSON.parse(this.selectedItems[0].value)
        : this.selectedItems[0].value;
      this.showModalCreate = true;
      this.isDisabled = true;
      this.titlePopup = "Update";
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        console.log(element.id);
      });
      this.showConfirmationModal = false;
    },
    async createUpdateProdutcs() {
      this.productModel.value =
        typeof this.jsonModel == "string"
          ? this.jsonModel
          : JSON.stringify(this.jsonModel);
      if (this.productModel.id) {
        this.productModel.modify_date = new Date().toISOString();
        api_loyalty.UpdateGlobalConfig(this.productModel)
          .then((data) => {
            if(data.isSuccess){
                this.message = {
                  message: "Config updated successfully.",
                  type: "success",
                };
            }else{
              this.message = {
                message: "Failed to create Config",
                type: "danger",
              };
            }            
            this.onRefreshData();
          })
          .catch((e) => {
              console.log(e)
              this.message = {
                message : "Failed to update Config.",
                type : 'danger'
              }
          })
      } else {
        this.productModel.create_date = new Date().toISOString();
        this.productModel.modify_date = new Date().toISOString();
        console.log(this.productModel);
        api_loyalty.AddGlobalConfig(this.productModel)
          .then((data) => {
              if(data.isSuccess){
                this.message = {
                  message: "Config created successfully.",
                  type: "success",
                };
              }else{
                this.message = {
                  message: "Failed to create Config",
                  type: "danger",
                };
              }
            this.onRefreshData();
          })
          .catch((e) => {
              console.log(e)
              if (e.response && e.response.status === 401)
              {
                this.message = {
                  message: "You don't have a permission",
                  type: 'danger'
                }
              } else
              {
                this.message = {
                  message: "Failed to create Config.",
                  type: 'danger'
                }
              }
          })
      }
      this.onResetForm();
      this.showModalCreate = false;
      this.onRefreshData();
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
  },
  watch: {
    watch_brand_code: function () {
      this.productModel.brandCode = this.watch_brand_code;
      this.onRefreshData();
    }
  }
};
</script>
<style></style>
